import { buildAuthorizationHeader, buildMapHeader } from "./authHeaders";
export const addAuthorizationInterceptor = (instance) => {
    instance.interceptors.request.use(async (config) => {
        const mapHeader = await buildMapHeader();
        const authHeader = await buildAuthorizationHeader();
        const customHeaders = { ...config.headers };
        customHeaders["Authorization"] = authHeader;
        customHeaders["x-map-access-token"] = mapHeader;
        return {
            ...config,
            headers: customHeaders,
        };
    });
};
//# sourceMappingURL=addAuthorizationInterceptor.js.map